import React from "react";
import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";

interface GnbItemMenuProps extends React.LiHTMLAttributes<HTMLLIElement> {
  href?: string;
  select?: boolean;
  emphatic?: boolean;
}

const GnbItemMenu = ({
  href,
  select,
  emphatic,
  children,
  ...rest
}: GnbItemMenuProps) => {
  return (
    <LiStyle {...rest} select={select} emphatic={emphatic}>
      {href ? (
        <NavLink
          to={href}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          {children}
        </NavLink>
      ) : (
        children
      )}
    </LiStyle>
  );
};

export default GnbItemMenu;

export const LiStyle = styled.li<{ select?: boolean; emphatic?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.3rem;
  position: relative;

  cursor: pointer;

  color: ${({ theme }) => theme.color.text.secondary};
  ${({ theme }) => theme.typography.body1.regular}
  line-height: ${({ theme }) => theme.typography.body3.regular.lineHeight};

  & .active {
    color: ${({ theme }) => theme.color.text.default};

    &::after {
      content: "";

      position: absolute;
      left: 0;
      right: 0;
      bottom: -0.3rem;
      border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey[900]};
    }
  }

  ${({ emphatic, theme }) =>
    emphatic &&
    css`
      color: ${theme.color.text.middleEmphasis};

      & .active::after {
        border-color: ${theme.color.text.middleEmphasis};
      }
    `}
`;
